import 'jquery-mask-plugin';

function DateTimeInput ($input, mask) {
  this.$input = $input;
  this.mask = mask;
}

DateTimeInput.prototype.addDateMask = function () {
  var self = this;
  self.$input.mask(self.mask);
};

$(document).ready(function () {
  $('input.js-datetime, input.js-time').each(function () {
    var dti = new DateTimeInput($(this), '00/00/0000 00:00');
    dti.addDateMask();
  });
  $('input.js-date').each(function () {
    var dti = new DateTimeInput($(this), '00/00/0000');
    dti.addDateMask();
  });
});
